export default __webpack_public_path__ + "static/media/logo-chubb.72985310.png";